import { rpcController } from "../rpc";
import { cacheResource } from "kea-resource";
import { ParamsCobranzaSemanal } from "app/models/requireme";

const controller = rpcController("CobranzaSemanal");

/**Resource del reporte cobranza semanal*/
export const RepCobranzaSemanal = cacheResource({
Generar: async (
parametros: ParamsCobranzaSemanal): Promise<string> =>
await controller("GenerarReporteCobranzaSemanal", {}, parametros)
}, {
}, {
})


// WEBPACK FOOTER //
// ./app/resources/items/cobranzasemanal.tsx